module.exports = __webpack_public_path__ + "img/badge-list-thumb-050.a60776ac.png";